import guardEpicsMap from "./guards.epics";
import * as guardReducers from "./guards.reducers";
import { objectValues } from "@ea/shared_components/utils/object";

const guardEpics = objectValues(guardEpicsMap);

export { guardReducers, guardEpics };
